import { useAuth } from "@/providers/auth/hooks";
import { useUserConfig } from "@/shared/domain/config/hooks";

import {
  DATE_TIME_FORMAT_CONFIG_KEY,
  type DateTimeFormatPreference,
  normalizePreference,
} from "./format";
import { useDateTimeFormat } from "./useDateTimeFormat";

/**
 * Whether the active format is the viewer's own: the request for their
 * stored preference has settled and `DateTimeFormatProvider` has published
 * it. When they stored none, the request failed, or no one is signed in,
 * their format is the app's default. A page that keeps text with times
 * written in it, rather than writing them again when the format changes,
 * waits for this before showing them.
 */
export function useViewerDateTimeFormatLoaded(): boolean {
  const { currentUser } = useAuth();
  const { data, isLoading } = useUserConfig<DateTimeFormatPreference>(
    DATE_TIME_FORMAT_CONFIG_KEY,
  );
  const active = useDateTimeFormat().preference;
  const viewers = normalizePreference(
    currentUser === null ? null : data ?? null,
  );
  return (
    !isLoading &&
    active.datePreset === viewers.datePreset &&
    active.clock === viewers.clock
  );
}
